import { useCallback, useState } from 'react'

export const useHintVisibilityByRef = () => {
  const [isHintVisible, setIsHintVisible] = useState(false)

  const textRef = useCallback(
    (element: HTMLSpanElement | HTMLDivElement | null) => {
      if (!element) return

      setIsHintVisible(element.scrollWidth > element.clientWidth)
    },
    []
  )

  return {
    isHintVisible,
    textRef,
  }
}
